/*

Talks: Following URLs assumed mandatory: Primary
Video, Slides are optional
*/
export const Talks = {
    TypeEmojiMap: {
        'Conference': '🗣️',
        'Podcast': '🎙️',
        'Training': '📚'
    },
    PreviousTalks: [
        {
            Title: "Public Speaking for Developers",
            Venue: "Mercari / MeltingHack",
            When: "Jun 2026",
            Type: "Training",
            Description: "Organized and delivered a public speaking workshop for 50 developers, covering technical presentation techniques and practical storytelling. The event culminated in an interactive 3-minute pitch session, where I coached attendees through their first public speaking experience.",
            URLs: {
                Primary: "https://www.linkedin.com/feed/update/urn:li:activity:7473670478176444416/",
                Slides: "https://kaustubhhiware.github.io/public-speaking-for-developers/?utm_source=resume",
            }
        },
        {
            Title: "Agent Skills for end-to-end Full-Stack Development",
            Venue: "Tokyo AI",
            When: "May 2026",
            Type: "Conference",
            Description: "Using agent skills to have a systematic, repeatable approach to agentic programming, embedding domain knowledge when creating skills, and creating self-improving memory patterns.",
            URLs: {
                Primary: "https://luma.com/zn7pp9rj",
                Slides: "https://github.com/kaustubhhiware/agent-skills-fullstack-development/blob/main/Agent%20Skills%20for%20full-stack%20development.pdf",
            }
        },
        {
            Title: "Shipping Through Chaos: Engineering Resilience Across Borders",
            Venue: "Techsummit.io, Amsterdam",
            When: "Sep 2025",
            Type: "Conference",
            Description: "Practices and processes that build resilience in systems and teams, operating across borders - technical, organizational or cultural.",
            URLs: {
                Primary: "https://techsummit.io/breakout-sessions/#summary6",
                Video: "https://youtu.be/g8xNcwgOOSg",
                Slides: "https://docs.google.com/presentation/d/1jbnj-h2y2LewPArvQEdkZJm0w-dJNycxWgztZ7yVP9U/edit?usp=sharing",
            }
        },
        {
            Title: "Moving to Japan as a Software Dev: Is It Worth It?",
            Venue: "Japan Dev",
            When: "Feb 2025",
            Type: "Podcast",
            Description: "I was interviewed about living in Japan, building a career as a software engineer here and everything that comes with it (language, visa, side hustles).",
            URLs: {
                Primary: "https://www.linkedin.com/feed/update/urn:li:activity:7301061137582710784/",
                Video: "https://youtu.be/lOMgRLAZZwg?si=kfyqs7so4UG6Zw7b",
            }
        },
        {
            Title: "Ship Code Faster",
            Venue: "Mercari Devdojo",
            When: "May 2024",
            Type: "Training",
            Description: "Mercari in-house technical training for newgrads, providing an action plan of how to effectively begin contributing to their teams, and ship code faster. The content had an overwhelmingly positive reception, as a result of which it was selected to be publicized externally.",
            URLs: {
                Primary: "https://engineering.mercari.com/en/learning-materials#:~:text=Kaustubh%20Hiware",
                Video: "https://youtu.be/iCVfIQlbrDo",
                Slides: "https://speakerdeck.com/mercari/devdojo-ship-code-faster-2024",
            }
        },
        {
            Title: "Podcast Co-Host",
            Venue: "Tech Culture Podcast",
            When: "2021 - 2022",
            Type: "Podcast",
            Description: "Conversations with top startup founders in Japan running successful businesses. We covered interesting trends in the Saas space (Software-as-a-Service).",
            URLs: {
                Primary: "https://x.com/techculturepod",
            }
        },
        {
            Title: "Using NLP for disaster management",
            Venue: "PyData Delhi (a NUMFocus Initiative)",
            When: "Aug 2019",
            Type: "Conference",
            Description: "During disasters, it is extremely crucial that the right resources are received to the victims within time. Disaster relief NGO's revealed that there is often mismanagement and lack of coordination. Also, often identifying right resources takes up a lot of crucial time. To aid this, we developed an algorithm that identifies locations from microblogs, upto 100x faster than SoTA StanfordNLP.",
            URLs: {
                Primary: "https://pydata.org/delhi2019/schedule/presentation/20/using-nlp-disaster-management/",
                Video: "https://youtu.be/aiVKhcGYqXw", // ToDo: Change to urls I can track
                Slides: "https://docs.google.com/presentation/d/10YXmxKwphN-k-tjI29CPdRmA3MHiCBXCogddA2B9cdQ/edit",
            }
        },
        {
            Title: "You should be doing Research right now",
            Venue: "Pragma, IIIT Allahabad",
            When: "Jan 2019",
            Type: "Conference",
            Description: "An argument for pursuing research as a college undergrad. Research publications are a great plus in academia as well as industry, providing exposure to unique problems & applications in the domain of Computer Science.",
            URLs: {
                Primary: "https://twitter.com/IIITAPragma/status/1085833015995953152",
                // Video: "https://youtu.be/tcX1xZbHfYI", // Video quality not great, recorded from an angle
                Slides: "https://docs.google.com/presentation/d/1269CAql3mZQPCYsTs6seRP2uiWGXT-UOfeRi0byxVTE/edit",
            },
        },
        {
            Title: "Innovations, Trends and Licensing in Open Source",
            Venue: "Open Source Summit, Kshitij, IIT Kharagpur",
            When: "Jan 2018",
            Type: "Conference",
            Description: "Importance of open source and how often we use it in daily life - ML & JS frameworks, research, self-learning cars, you name it. Briefly spoke about philosophy and need of open-source. The talk concluded with importance of licensing in open source and why everyone should do it.",
            URLs: {
                Primary: "https://www.facebook.com/kossiitkgp/posts/1588201874590140",
                Video: "https://youtu.be/lk4ciY3NSbA",
                Slides: "https://docs.google.com/presentation/d/1DUu_Q5wV3HMm2sQ9vGdB9pDUjgK9BUgKiGlvIhtmsoA/edit",
            },
        },
    ],
}

export default Talks;
